import { defineComponent as _defineComponent } from 'vue'
import { computed, useStore } from '@nuxtjs/composition-api'
import useRoleManagement from '~/composeables/roleManagement/roleManagement'
import useUserStuff from '~/composeables/userStuff/userStuff'


export default /*#__PURE__*/_defineComponent({
  __name: 'LiveChatComp',
  setup(__props) {

const store = useStore()

const whitelabelConfig = computed(() => store.getters['whitelabel/getConfig'])
const userDetails = computed(() => store.getters['access/getUserDetails'])

const { isExternalUsage } = useRoleManagement()
const { combinedName } = useUserStuff()

const liveChatCredentials = computed(() => {
  if (!userDetails.value) { return null }
  return {
    license: isExternalUsage.value ? null : whitelabelConfig.value.liveChatLicenseKey,
    group: whitelabelConfig.value.liveChatGroupId || process.env.LIVECHAT_GROUP,
    customerName: combinedName.value.length ? combinedName.value : userDetails.value.email,
    customerEmail: userDetails.value.email
  }
})

return { __sfc: true,store, whitelabelConfig, userDetails, isExternalUsage, combinedName, liveChatCredentials }
}

})